import { render, staticRenderFns } from "./sysitem.vue?vue&type=template&id=4f4cf6d7&scoped=true&"
import script from "./sysitem.vue?vue&type=script&lang=js&"
export * from "./sysitem.vue?vue&type=script&lang=js&"
import style0 from "./sysitem.vue?vue&type=style&index=0&id=4f4cf6d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cf6d7",
  null
  
)

export default component.exports